<div class="header-helper">Change your password. Click “Update” when done.</div>

<div class="content content-with-elevation">

<form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" novalidate>

  <common-alerts [error]="errorMessage"></common-alerts>

  <common-alerts [successMessage]="successMessage"></common-alerts>

  <div class="grid-x form-group">

    <div class="cell large-4 medium-6 small-12">
      <label>Current Password
        <input formControlName="currentPassword" type="password"
               class="input-group-custom" required>
      </label>

      <label>New Password
        <input formControlName="newPassword" type="password"
               class="input-group-custom" required>
        <div style="width: 90%">
          <password-strength-meter [password]="changePasswordForm.controls.newPassword.value"
                                   [minPasswordLength]="8"></password-strength-meter>
        </div>
      </label>

      <label>Confirm new password
        <input formControlName="verifyNewPassword" type="password"
               class="input-group-custom" required>
      </label>

    </div>

    <div class="cell large-8 medium-6 small-12">
      <div class="grid-y">
        <div class="content-header">
          Password Requirements:
        </div>
        <div>
          <fa-icon [icon]="(changePasswordForm.controls.newPassword.errors && changePasswordForm.controls.newPassword.errors.minimumLength)
                ? 'times-circle': 'check'"></fa-icon> Minimum 8 characters in length
        </div>
        <div>
          <fa-icon [icon]="(changePasswordForm.controls.newPassword.errors && changePasswordForm.controls.newPassword.errors.spaces)
                ? 'times-circle': 'check'"></fa-icon> No leading or trailing white spaces
        </div>
        <div>
          <fa-icon [icon]="(changePasswordForm.controls.newPassword.errors && changePasswordForm.controls.newPassword.errors.numbers)
                ? 'times-circle': 'check'"></fa-icon> Include numeric characters (0-9)
        </div>
        <div>
          <fa-icon [icon]="(changePasswordForm.controls.newPassword.errors && changePasswordForm.controls.newPassword.errors.upperCase)
                ? 'times-circle': 'check'"></fa-icon> Include uppercase (A-Z)
        </div>
        <div>
          <fa-icon [icon]="(changePasswordForm.controls.newPassword.errors && changePasswordForm.controls.newPassword.errors.lowerCase)
                ? 'times-circle': 'check'"></fa-icon> Include lowercase (a-z)
        </div>
        <div>
          <fa-icon [icon]="(changePasswordForm.controls.newPassword.errors && changePasswordForm.controls.newPassword.errors.specialCharacters)
                ? 'times-circle': 'check'"></fa-icon> Include special characters such as &#64;, #, !, &, ^,*, ~, (, )
        </div>
      </div>
    </div>
  </div>
  <div class="grid-x  align-end">
    <div class="save-cancel-button-group ">
      <button class="iana-button"  type="submit"
              [disabled]="!changePasswordForm.valid">Update
      </button>
      <button class="iana-button-cancel" type="reset" (click)="cancel()">Cancel</button>
    </div>
  </div>
</form>
</div>
